import { MutableRefObject, useRef } from 'react';

import { networkCallWithApisauceWithHeaders } from '@nw/shared/data-access';

import FileUploadService from '../../services/FileUploadService';
import FileUploadAPIService from '../../services/FileUploadService/index.api';

import { useAccountsRefreshAuthTokens } from '../useAccountsRefreshAuthTokens';

const useFileUploadConfigServices = () => {
  const { refreshTokenApi, getAccessToken, getRefreshToken } =
    useAccountsRefreshAuthTokens();
  const fileUploadConfigRef: MutableRefObject<FileUploadService | null> =
    useRef(null);

  if (fileUploadConfigRef.current === null) {
    fileUploadConfigRef.current = new FileUploadAPIService(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }
  return { fileUploadConfigServices: fileUploadConfigRef.current };
};

export { useFileUploadConfigServices };
